import React, { useCallback, useEffect, useState } from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

import DialogContent from "@mui/material/DialogContent";
import Grid from "@mui/material/Grid";
import { notBlank } from "../../util/ext";
import { useAllModules } from "../../manage-subscriptions/subscriptionService";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Skeleton } from "@mui/material";

const DefaultModulesDialog = ({ open, onCancel, onApply }) => {
  const [selectedModule, setSelectedModule] = useState(null);
  const [modules, setModules] = useState([]);

  const allModules = useAllModules();
  useEffect(() => {
    if (allModules.isSuccess && notBlank(allModules.data)) {
      setModules(allModules.data);
    }
  }, [allModules.isSuccess, allModules.data]);

  const handleModuleChange = useCallback((_event, module) => {
    setSelectedModule(module);
  }, []);

  const handleApply = async () => {
    if (notBlank(selectedModule)) {
      onApply(selectedModule);
    } else {
      onCancel();
    }
  };

  return (
    <Dialog open={open}>
      <DialogTitle id="form-dialog-title">Add Default Module</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Select a Module to add to the Default Modules list.
        </DialogContentText>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            {notBlank(modules) ? (
              <Autocomplete
                id="modules"
                options={modules}
                getOptionLabel={option => option.displayName || option.name}
                value={selectedModule || null}
                onChange={handleModuleChange}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Modules"
                    placeholder="Select..."
                  />
                )}
              />
            ) : (
              <Skeleton variant="text" />
            )}
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleApply} color="primary">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DefaultModulesDialog;
